export default [

  {
    path: '/online/preconsult',
    meta: {
      title: '预问诊'
    },
    component: () => import('../pages/online/preconsult.vue')
  },
  {
    path: '/online/order/succeed',
    meta: {
      title: '网络诊间'
    },
    component: () => import('../pages/online/succeed.vue')
  }
]



// WEBPACK FOOTER //
// ./h5/router/online.js